import ArchiveList from '@/features/archive/components/ArchiveTabs/ArchiveList'
import { FC } from 'react'

const Page: FC = () => {
    return <ArchiveList />
}

export default Page
